import { Box, Circle, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { InviteCardProps } from "../types";
import { useSnapshot } from "valtio";
import { editorState } from "../../../../utils/editor";

const formatEventDate = (date: Date | string | undefined): string => {
  if (!date) return "TBD";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

const GuestInviteSample: React.FC<InviteCardProps> = ({
  w,
  h,
  px,
  helloText,
  inviteText,
  circleSize,
  nameSize,
  scheduleSize,
  venueSize,
  letUsKnowSize,
  btnBg,
  btnSize,
  btnW,
  border,
}) => {
  const { groomFirstName, brideFirstName, eventSchedules, mainContent } =
    useSnapshot(editorState);

  // Get first two events or use placeholders
  const event1 = eventSchedules?.[0];
  const event2 = eventSchedules?.[1];

  const event1Name = event1?.eventType || "Ceremony";
  const event1Location = event1?.address || "Venue TBD";
  const event1Date = formatEventDate(event1?.date || mainContent?.date);

  const event2Name = event2?.eventType || "Reception";
  const event2Location = event2?.address || "Venue TBD";
  const event2Date = formatEventDate(event2?.date || mainContent?.date);
  return (
    <Flex
      flexDir={"column"}
      bg={"#fff"}
      py={"9.8px"}
      px={px ?? "44px"}
      border={border ?? "1px solid #00000033"}
      w={w ?? "full"}
      h={h ?? "full"}
      maxW={"398px"}
      maxH={"600px"}
      minH={"450px"}
      alignItems={"center"}
    >
      <Box
        bg={"#f9f9f9"}
        borderRadius={"18.59px"}
        fontFamily={"font4"}
        my={"7px"}
        py={"7.5px"}
        px={"14.7px"}
      >
        <Text fontSize={helloText ?? "9.96px"} textTransform={"uppercase"}>
          👋🏾 Hello Guest
        </Text>
      </Box>
      <Text
        fontFamily={"font4"}
        fontSize={inviteText ?? "12.45px"}
        pb={"5.88px"}
        textAlign={"center"}
      >
        You’re invited to our wedding
      </Text>
      <Circle bg={"#CFFFDF"} size={circleSize ?? "56px"}>
        <Image src="/images/One Ring.webp" />
      </Circle>
      <Text
        fontFamily={"font1"}
        fontSize={nameSize ?? "24.9px"}
        py={"6px"}
        textAlign={"center"}
      >
        {brideFirstName} & {groomFirstName}
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={scheduleSize ?? "8.71px"}
        pb={"5.15px"}
        textTransform={"uppercase"}
        textAlign={"center"}
      >
        This is a sample Schedule
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={venueSize ?? "9.96px"}
        textAlign={"center"}
      >
        {event1Name}
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={venueSize ?? "9.96px"}
        textAlign={"center"}
        pb={"6.28px"}
      >
        @ {event1Location} | {event1Date}
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={venueSize ?? "9.96px"}
        textAlign={"center"}
      >
        {event2Name}
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={venueSize ?? "9.96px"}
        textAlign={"center"}
        pb={"11.21px"}
      >
        @ {event2Location} | {event2Date}
      </Text>
      <Text
        fontFamily={"font4"}
        fontSize={letUsKnowSize ?? "8.71px"}
        textAlign={"center"}
        pb={"17px"}
        w={"151.26px"}
      >
        Please let us know if you can make it or not, so we can plan properly
      </Text>
      <Flex
        bg={btnBg ?? "#000"}
        borderRadius={"29.41px"}
        w={btnW ?? "195.2px"}
        py={"11px"}
        justifyContent={"center"}
        alignItems={"center"}
        fontSize={btnSize ?? "0.765rem"}
        fontFamily={"font4"}
        textTransform={"uppercase"}
        letterSpacing={"1px"}
        fontWeight={600}
        color={"#fff"}
      >
        This is a sample
      </Flex>
    </Flex>
  );
};
export default GuestInviteSample;
